import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 301,
  name: 'Moved Permanently',
  description:
    'The requested resource has been permanently moved to a new URL. The server includes the new location in the Location header. Browsers and search engines will update their references to use the new URL.',
  causes: [
    'The website moved to a new domain (e.g., example.com to newexample.com) and set up permanent redirects.',
    'URL structure changed — pages moved from /old-path to /new-path and the server redirects old URLs.',
    'HTTP-to-HTTPS migration: the server permanently redirects all HTTP requests to HTTPS.',
  ],
  fixes: [
    'Update your links and bookmarks to the new URL from the Location header. Browsers cache 301 redirects aggressively, so the old URL will auto-redirect.',
    'If you control the server, ensure the Location header points to a valid destination. Avoid redirect chains (A -> B -> C) — redirect directly to the final URL.',
    'For SEO, 301 is the correct redirect for permanent moves. Search engines transfer link equity to the new URL. Verify redirects with curl -I or browser dev tools.',
  ],
  monitoringTip:
    'Uptrack follows redirects by default and checks the final destination. If your redirect chain breaks or leads to an error page, Uptrack alerts you. You can also monitor the original URL to verify the redirect stays in place.',
}

export const Route = createFileRoute('/_site/http/301')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
